module.exports = __webpack_public_path__ + "static/img/3.ac04bfe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/zh/3.png
// module id = dF9/
// module chunks = 0